<header class="header">
  <!-- Reset Password Notification (Top Right) -->
  <div *ngIf="resetPasswordNotification" [ngClass]="resetPasswordNotificationType === 'success' ? 'success-notification' : 'error-notification'">
    <svg *ngIf="resetPasswordNotificationType === 'success'" class="success-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#10b981"/>
      <path d="M8 12L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <svg *ngIf="resetPasswordNotificationType === 'error'" class="error-notification-icon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="12" r="10" fill="#dc2626"/>
      <path d="M15 9L9 15M9 9L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <span [ngClass]="resetPasswordNotificationType === 'success' ? 'success-notification-message' : 'error-notification-message'">{{ resetPasswordNotification }}</span>
  </div>

  <div class="header-left">
    <div class="logo-section" *ngIf="!sidebarOpen">
      <div class="logo-container">
        <div class="logo-shape">
          <img src="assets/public/Aeroplast Logo.svg" alt="Aero Plast Logo" class="logo-image">
        </div>
        <!-- <div class="logo-text-container">
          <h2 class="logo-text">Aero Plast</h2>
          <p class="logo-subtitle">Since 1978</p>
        </div> -->
      </div>
    </div>
  </div>
  <div class="header-right">
    <div class="user-menu-container">
      <div class="user-menu" (click)="toggleUserMenu($event)">
        <div class="user-avatar">
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="16" cy="16" r="16" fill="#e5e7eb"/>
            <circle cx="16" cy="12" r="5" fill="#9ca3af"/>
            <path d="M8 24C8 20 10 18 16 18C22 18 24 20 24 24" stroke="#9ca3af" stroke-width="2" fill="none"/>
          </svg>
        </div>
        <div class="user-info">
          <span class="user-name">{{ getUserName() }}</span>
          <span class="user-email">{{ getUserEmail() }}</span>
          <span class="user-role">Role : {{ getUserType() }}</span>
        </div>
        <span class="dropdown-arrow" [class.rotated]="showUserMenu">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 4.5L6 7.5L9 4.5" stroke="#374151" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
      </div>
      <div class="dropdown-menu" *ngIf="showUserMenu" (click)="$event.stopPropagation()">
        <div class="dropdown-item" (click)="openResetPasswordModal(); $event.stopPropagation()">
          <span class="dropdown-text">Reset Password</span>
        </div>
        <div class="dropdown-item logout-item" (click)="logout(); $event.stopPropagation()">
          <span class="logout-text">🚪 Logout</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Reset Password Modal -->
  <div class="modal-overlay" *ngIf="showResetPasswordModal" (click)="closeResetPasswordModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>Reset Password</h3>
        <button type="button" class="modal-close" (click)="closeResetPasswordModal()">&times;</button>
      </div>
      <form (ngSubmit)="resetPassword()">
        <div class="form-group">
          <label>New Password<span class="required-asterisk">*</span></label>
          <div class="password-input-wrapper">
            <input [type]="showNewPassword ? 'text' : 'password'" class="form-control" [class.error]="newPasswordError" [(ngModel)]="resetPasswordForm.newPassword" name="newPassword" placeholder="Enter New Password" required minlength="6">
            <button type="button" class="password-toggle" (click)="toggleNewPasswordVisibility()">
              <svg *ngIf="!showNewPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="10" cy="10" r="3" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="showNewPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 3L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div *ngIf="newPasswordError" class="field-error">{{ newPasswordError }}</div>
        </div>
        <div class="form-group">
          <label>Confirm Password<span class="required-asterisk">*</span></label>
          <div class="password-input-wrapper">
            <input [type]="showConfirmPassword ? 'text' : 'password'" class="form-control" [class.error]="confirmPasswordError" [(ngModel)]="resetPasswordForm.confirmPassword" name="confirmPassword" placeholder="Confirm New Password" required minlength="6">
            <button type="button" class="password-toggle" (click)="toggleConfirmPasswordVisibility()">
              <svg *ngIf="!showConfirmPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <circle cx="10" cy="10" r="3" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <svg *ngIf="showConfirmPassword" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10 3C5 3 1.73 7.11 1 10C1.73 12.89 5 17 10 17C15 17 18.27 12.89 19 10C18.27 7.11 15 3 10 3Z" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M3 3L17 17" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
          </div>
          <div *ngIf="confirmPasswordError" class="field-error">{{ confirmPasswordError }}</div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-cancel" (click)="closeResetPasswordModal()">Cancel</button>
          <button type="submit" class="btn btn-submit" [disabled]="resetPasswordLoading">
            {{ resetPasswordLoading ? 'Resetting...' : 'Reset Password' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</header>

